import ExpenseForm from "./ExpenseForm";
const ExpenseList = ({ expenses, total }) => {
  return (
    <>
      <h2>Total:{total}</h2>
      <table border="1" name="expense-tbl" id="expense-tbl">
        <tr>
          <th colspan="3">Expenses</th>
        </tr>
        <tr>
          <th>Description</th>
          <th>Amount</th>
          <th>Category</th>
        </tr>
        {expenses.map((expense, id) => (
          <tr key={expense.id}>
            <td>{expense.description}</td>
            <td>{expense.amount}</td>
            <td>{expense.category}</td>
          </tr>
        ))}
      </table>
    </>
  );
};
export default ExpenseList;
